module.exports = __webpack_public_path__ + "static/img/card_5_2.e2a1215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_5_2.png
// module id = 4Xeb
// module chunks = 0